import { ModalActionTypes, MODAL_SHOW } from "../actions/modal.actions";

const initialState = {
  title: "",
  visible: false
};
export const ModalReducer = (
  state = initialState,
  action: ModalActionTypes
) => {
  switch (action.type) {
    case MODAL_SHOW:
      return action.payload;
    default:
      return state;
  }
};
